var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-mail" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon inbox-icon" },
              [_c("md-icon", [_vm._v("inbox")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.incomingMails")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.incomingMailsDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [_c("MailInboxChart", { attrs: { filters: _vm.filters } })],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon send-icon" },
              [_c("md-icon", [_vm._v("send")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.sentMails")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.sentMailsDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [_c("MailSendChart", { attrs: { filters: _vm.filters } })],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }